import React from 'react';
import LocationTemplate from './LocationTemplate';

const DortchesPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Dortches"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27824"]}
      latitude={36.0446}
      longitude={-77.8436}
      population={935}
      historicalFact="Incorporated in 1903, named after William Dortch, a NC state senator."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Nashville, NC",
        "Red Oak, NC",
        "Spring Hope, NC",
        "Elm City, NC",
        "Sharpsburg, NC",
        "Battleboro, NC",
        "Castalia, NC"
      ]}
    />
  );
};

export default DortchesPage;